import { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { Navigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";

export default function LoginPage() {
  const { user, loading, login } = useAuth();
  const [searchParams] = useSearchParams();
  const reason = searchParams.get("reason");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(reason === "session_expired" ? "Your session expired — please sign in again." : "");
  const [submitting, setSubmitting] = useState(false);

  if (loading) return <div className="min-h-screen bg-[#0A1628] flex items-center justify-center"><Loader2 className="w-6 h-6 text-[#F59073] animate-spin" /></div>;
  if (user && user.role === "accountant") return <Navigate to="/admin/accountant/bookkeeping" replace />;
  if (user) return <Navigate to="/admin/dashboard" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email, password);
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Invalid credentials");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A1628] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <h1 className="font-outfit font-bold text-3xl text-white mb-2">wedowedo</h1>
          <p className="text-sm text-[#857973] font-mono tracking-[0.15em]">ADMIN PANEL</p>
        </div>

        <form onSubmit={handleSubmit} data-testid="admin-login-form" className="bg-[#0F1F3A] border border-[#1E3050] rounded-sm p-8 space-y-5">
          <div>
            <label className="font-mono text-[10px] tracking-[0.2em] text-[#857973] mb-2 block">EMAIL</label>
            <input
              data-testid="admin-login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-[#0A1628] border border-[#1E3050] text-white px-4 py-2.5 rounded-sm focus:border-[#D9A872] focus:ring-1 focus:ring-[#00F0FF] outline-none text-sm"
              placeholder="admin@wedowedo.se"
            />
          </div>
          <div>
            <label className="font-mono text-[10px] tracking-[0.2em] text-[#857973] mb-2 block">PASSWORD</label>
            <input
              data-testid="admin-login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-[#0A1628] border border-[#1E3050] text-white px-4 py-2.5 rounded-sm focus:border-[#D9A872] focus:ring-1 focus:ring-[#00F0FF] outline-none text-sm"
            />
          </div>

          {error && <p data-testid="admin-login-error" className="text-red-500 text-sm">{error}</p>}

          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={submitting}
            className="w-full bg-[#F59073] text-black font-medium py-3 rounded-sm hover:shadow-[0_0_25px_rgba(245,144,115,0.5)] transition-all duration-300 disabled:opacity-50 flex items-center justify-center gap-2 text-sm"
          >
            {submitting && <Loader2 className="w-4 h-4 animate-spin" />}
            Sign in
          </button>
        </form>
      </div>
    </div>
  );
}
